import { TabItem, Tabs } from '@navi/web-ui/lib/components';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { TabItemKey } from '@navi/web-ui/lib/components/Tabs/types';
import { interpolatePathParams } from '@cp/src/utils/interpolate';
import APP_ROUTES from '@cp/src/layout/Routes';
import { LocalStorage } from '@cp/src/utils/StorageUtils';
import { ANOMALY_TRACKER_TABS } from './constants';
import Header from './components/Header';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { RootState } from '@cp/src/store';
import { useDispatch, useSelector } from 'react-redux';
import { AnomalyStatus, AnomalyTableKeys, TabsKey } from './types';
import { useEffect } from 'react';
import { getAnomalyTickets } from './actions/AnomalyTrackerAction';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';

const AnomalyTracker = () => {
  const { tabId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const paramsMap: Record<string, string> = LocalStorage.getItem('paramsMap') || {};
  const totalOpenTickets = useSelector(
    (state: RootState) => state?.anomalyTracker?.openTickets?.pages?.totalElements
  );
  const totalClosedTickets = useSelector(
    (state: RootState) => state?.anomalyTracker?.closedTickets?.pages?.totalElements
  );
  const handleTabChange = (updateTabId: TabItemKey) => {
    if (tabId !== updateTabId) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_ANOMALY_TRACKER_TAB_CHANGE, {
        tabName: updateTabId
      });
      const updatedUrl = interpolatePathParams(APP_ROUTES.ANOMALY_TRACKER.path, {
        tabId: String(updateTabId)
      });
      const currentParams = paramsMap[updatedUrl] || '';
      navigate(updatedUrl + currentParams);
    }
  };

  const getDefaultParams = (params: any) => ({
    ...params,
    pageSize: params?.pageSize || 10,
    pageNo: params?.pageIndex || 0
  });

  useEffect(() => {
    const queryParams = readQueryParams();
    if (tabId === TabsKey.CLOSED_ANOMALY) {
      const paramsOpenAnomalyTab = queryParams[AnomalyTableKeys.OPEN_ANOMALY_TABLE] || {};
      const defaultParamsOpenAnomalyTab = getDefaultParams(paramsOpenAnomalyTab);
      delete defaultParamsOpenAnomalyTab?.pageIndex;
      dispatch(getAnomalyTickets(AnomalyStatus.OPEN, defaultParamsOpenAnomalyTab));
    }
    if (tabId === TabsKey.OPEN_ANOMALY) {
      const paramsClosedAnomalyTab = queryParams[AnomalyTableKeys.CLOSED_ANOMALY_TABLE] || {};
      const defaultParamsClosedAnomalyTab = getDefaultParams(paramsClosedAnomalyTab);
      delete defaultParamsClosedAnomalyTab?.pageIndex;
      dispatch(getAnomalyTickets(AnomalyStatus.CLOSED, defaultParamsClosedAnomalyTab));
    }
  }, []);

  return (
    <div>
      <Header />
      <Tabs
        tabsClassName={styles.tabContainerClass}
        selectedTabKey={tabId}
        defaultSelectedKey={tabId}
        onTabChange={handleTabChange}
        contentClassName={styles.tabContent}
      >
        {ANOMALY_TRACKER_TABS.map(tab => {
          const totalTickets =
            tab?.key === TabsKey.OPEN_ANOMALY ? totalOpenTickets : totalClosedTickets;
          let tabValue;
          if (totalOpenTickets >= 0 && totalClosedTickets >= 0) {
            tabValue = `${tab.value} (${totalTickets})`;
          } else tabValue = tab.value;
          return (
            <TabItem key={tab.key} label={tabValue}>
              {tab.component}
            </TabItem>
          );
        })}
      </Tabs>
    </div>
  );
};

export default AnomalyTracker;
